export default "__VITE_ASSET__DtJRK0XY__"